import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import logo from '../../assets/image/headerLogo.svg';

const MobileUnsupported = () => {
  const translate = useIntl();

  return (
    <div className="mobile-unsupported">
      <div className="mobile-unsupported__card">
        <img className="mobile-unsupported__logo" src={logo} alt="Open Forest Protocol" />
        <p className="mobile-unsupported__title">
          {translate.formatMessage({ id: 'mobile.unsupported.title' })}
          <br />
          {translate.formatMessage({ id: 'mobile.unsupported.subtitle' })}
        </p>
        <p className="mobile-unsupported__help">

          <FormattedMessage
            id="mobile.unsupported.help"
            values={{
              link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="text-anchor">{chunks}</a>,
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default MobileUnsupported;
